<template>
  <v-col md="12" sm="6" cols="12">
    <v-card class="d-flex align-center">
      <div
        class="
          d-flex
          justify-space-between
          flex-wrap flex-md-nowrap flex-column flex-md-row
        "
      >
        <div class="mx-auto">
          <v-img
            width="150"
            height="100%"
            :src="getImage(biodata.picts)"
            v-bind:alt="biodata.picts"
          ></v-img>
        </div>
        <v-divider :vertical="$vuetify.breakpoint.mdAndUp"></v-divider>
        <div>
          <v-card-title v-text="biodata.nama"></v-card-title>
          <v-card-text>
            <span class="mdi mdi-cellphone"></span> {{ biodata.notelp }}
          </v-card-text>
        </div>
      </div>
    </v-card>
  </v-col>
</template>

<script>
export default {
  data: () => ({
    location: "@/assets/images/about/",
  }),
  props: ["biodata"],
  methods: {
    getImage(picts) {
      return require("../assets/images/about/" + picts);
    },
  },
};
</script>